import { Typography } from 'antd'
import { TitleProps } from 'antd/es/typography/Title'
import { useIsCompactMenu } from 'shared/hooks/useIsCompactMenu'

// На телефоне и планшете открытый раздел кабинета назван в меню-облачке,
// поэтому заголовок страницы не дублируем
export const SectionTitle: React.FC<TitleProps> = (props) => {
  const isCompactMenu = useIsCompactMenu()

  if (isCompactMenu) {
    return null
  }

  return <Typography.Title {...props} />
}
